import script from "./LinkBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkBtn.vue?vue&type=script&setup=true&lang=js"

import "./LinkBtn.vue?vue&type=style&index=0&id=7650262a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7650262a"]])

export default __exports__